/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Identifiers of outlets inside the cart details view.
 */
export enum CartOutlets {
  ITEM = 'cx-cart-item',
  LIST_ITEM = 'cx-cart-item-list-row',
  ITEM_DETAILS = 'cx-cart-item.details',
  ITEM_CONFIGURATOR_ISSUES = 'cx-configurator-issues-notification',
  ITEM_BUNDLE_DETAILS = 'cx-cart-item.bundle-details',
  ITEM_DELIVERY_DETAILS = 'cx-cart-item.delivery-details',
  ORDER_SUMMARY = 'cx-order-summary',
  CART_ITEM_LIST = 'cx-cart-item-list',
  ADD_TO_CART_CONTAINER = 'cx-add-to-cart-container',
  PICKUP_INFO = 'cx-pickup-info',
  ADD_TO_CART_PICKUP_OPTION = 'cx-add-to-cart-pickup-option',
}
